export const FINANCIAL_TRANSACTIONS = 'Financial';
export const RECENT_TRANSACTIONS = 'Recent';
export const PRODUCT_TRANSACTIONS = 'Product';
